import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'NANDA_DIAGNOSTIC';

export default createListReducer(TEMPLATE_NAME);
